import {Col, Row} from "react-bootstrap";
import {useEffect, useState} from "react";

// This component makes the text and the input align next to each other. Also calculates the rows needed for input.
export default function InputRow({title, value, onChange}) {

    const [rows, setRows] = useState(0)

    useEffect(() => {
        if(value) {
            let count = 0
            for (let row of value.split(/\r\n|\r|\n/)) {
                count += Math.ceil(row.length / 120) || 1
            }
            setRows(count)
        }
    }, [value])


    return <Row className={"my-1 d-flex align-content-center"}>
        <Col className={"d-flex align-items-center"} lg={2}>{title}</Col>
        <Col lg={10}><textarea className={"form-control"} style={{width: "100%"}} rows={rows} value={value} onChange={e => onChange(e)}/></Col>
    </Row>
}